import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    logged: false,
    token: '',
    user: '',
    companyDedicated: {},
    tokenDedicated: null,
    notification: false,
  },
  mutations: {
    loading(state, value) {
      state.loading = value
    },
    logged(state, value) {
      state.logged = value
    },
    token(state, value) {
      state.token = value
    },
    user(state, value) {
      state.user = value
    },
    companyId(state, value) {
      state.user.company.id = value
    },
    companyDedicated(state, value) {
      state.companyDedicated = value
    },
    tokenDedicated(state, value) {
      state.tokenDedicated = value
    },
    notification(state, value) {
      state.notification = value
    },
  },
  actions: {
    startLoading() {
      this.commit('loading', true)
    },
    endLoading() {
      this.commit('loading', false)
    },
    setLogin(context, loginData) {
      context.commit('user', loginData.user)
      context.commit('token', loginData.token)
      context.commit('notification', loginData.user.hasNewEvent)
      context.commit('logged', true)
    },
    logout(context) {
      context.commit('user', null)
      context.commit('token', null)
      context.commit('logged', false)
    },
    setCompanyId(context, id) {
      context.commit('companyId', id)
    },
    setCompanyDedicated(context, data) {
      context.commit('companyDedicated', data)
      context.commit('tokenDedicated', null)
    },
    setTokenDedicated(context, data) {
      context.commit('tokenDedicated', data)
    },
    setNotification(context, value) {
      context.commit('notification', value)
    }
  },
  getters: {
    isLoading: state => {
      return state.loading
    },
    isLogged: state => {
      return state.logged
    },
    getToken: state => {
      return state.token
    },
    getUser: state => {
      return state.user
    },
    getCompanyId: state => {
      return state.user.company.id
    },
    getCompany: state => {
      return state.user.company
    },
    getCompanyDedicated(state) {
      return state.companyDedicated
    },
    getTokenDedicated(state) {
      return state.tokenDedicated
    },
    hasNotification: state => {
      return state.notification
    }
  }
})



// WEBPACK FOOTER //
// /src/store/index.js